<template>
  <div id="login">
    <img src="/static/img/logo.png" class="center-block logo">

    <div class="text-center col-sm-12">
      <!-- login form -->
      <form @submit.prevent="auth">
        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-envelope"></i></span>
          <input class="form-control" name="username" placeholder="Digite o seu e-mail" type="text" v-model="user.email">
        </div>

        <div class="input-group">
          <span class="input-group-addon"><i class="fa fa-lock"></i></span>
          <input class="form-control" name="password" placeholder="Digite a sua senha" type="password" v-model="user.password">
        </div>
        <button type="submit" v-bind:class="'btn btn-primary btn-lg '">Acessar</button>
      </form>

      <!-- errors -->
      <div v-if=response class="text-red"><p class="vertical-5p lead">{{response}}</p></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Login',
  data() {
    return {
      showDismissibleAlert: false,
      messageAlert: '',
      user: {}
    }
  },
  methods: {
    track () {
      this.$ga.page('/login')
    },
    auth() {
      console.log('Clicou no Botão')
      let qs = require('qs')
      console.log(this.user)
      let data = qs.stringify(this.user)
      window.axios.post('/auth/token', data).then((res) => {
        console.log('Recebi a resposta ' + res)
        window.axios.defaults.headers.common['Authorization'] = res.data.token
        window.localStorage.setItem('token', res.data.token)
        window.localStorage.setItem('name', res.data.name)
        this.$store.state.Users.name = res.data.name
        console.log(res.data.token)
        this.$store.state.Users.avatar = '/static/img/stock/user.png'
        this.$router.push({path: '/'})
      }).catch((err) => {
        console.log('Deu Zica')
        if (err.response.request.status === 401) {
          this.showDismissibleAlert = true
          this.messageAlert = 'Login/Senha inválidos'
          alert('Login/Senha inválidos')
        }
      })
    },
    toggleLoading() {
      this.loading = this.loading === '' ? 'loading' : ''
    }
  }
}
</script>

<style>
#login {
  padding: 1em;
}

html,
body,
.container-table {
  height: 100%;
  background-color: #282b30 !important;
}
.container-table {
  display: table;
  color: white;
}
.vertical-center-row {
  display: table-cell;
  vertical-align: middle;
}
.vertical-20p {
  padding-top: 20%;
}
.vertical-10p {
  padding-top: 10%;
}
.vertical-5p {
  padding-top: 5%;
}
.logo {
  width: 15em;
  padding: 3em;
}

.input-group {
  padding-bottom: 2em;
  height: 4em;
  width: 100%;
}

.input-group span.input-group-addon {
  width: 2em;
  height: 4em;
}

@media (max-width: 1241px) {
  .input-group input {
    height: 4em;
  }
}
@media (min-width: 1242px) {
  form {
    padding-left: 20em;
    padding-right: 20em;
  }

  .input-group input {
    height: 6em;
  }
}

.input-group-addon i {
  height: 15px;
  width: 15px;
}
</style>



// WEBPACK FOOTER //
// Login.vue?1f278d32